import { Component, OnInit } from '@angular/core';
import { LocationStrategy } from '@angular/common';
import { fromEvent, Observable, Subscription } from 'rxjs';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit{

  onlineEvent!: Observable<Event>;
  offlineEvent!: Observable<Event>;
  subscriptions: Subscription[] = [];
  connectionStatusMessage!: string;
  connectionStatus!: string;

constructor( 
  private location: LocationStrategy,
  private snackbar: MatSnackBar
  ){
    history.pushState(null, 'null', window.location.href);  
    this.location.onPopState(() => {
    history.pushState(null, 'null', window.location.href);
});
}

ngOnInit(): void {
  this.onlineEvent = fromEvent(window, 'online');
  this.offlineEvent = fromEvent(window, 'offline');

  this.subscriptions.push(this.onlineEvent.subscribe(e => {
    this.connectionStatusMessage = 'Back to online';
    this.connectionStatus = 'online';
    this.snackbar.open( this.connectionStatusMessage, '',{duration: 3000,panelClass: ['online'],});
  }));

  this.subscriptions.push(this.offlineEvent.subscribe(e => {
    this.connectionStatus = 'offline';
    this.snackbar.open( 'Connection lost! You are not connected to internet', '',{panelClass:['offline']});
  }));
  
}



}
